import Box from "@mui/material/Box";
import { useState } from "react";
import FilterComponent from "../../../../../ReusableFIlterComponent/FilterComponent";
import { useSelector } from "react-redux";
import store from "../../../../../../store";
import {
  setSelectedIndustry,
  setSelectedStatus,
  setSelectedTeritory,
  setSelectedType,
  setSelectedWebsite,
  setSyncEnabled,
} from "../../../../../../features/websiteActionSlice";

interface WebsiteActionFilterProps {
  websiteList: any;
}

export default function WebsiteActionFilter({
  websiteList,
}: WebsiteActionFilterProps) {
  const [searchType, setSearchType] = useState("");
  const [searchTeritory, setSearchTeritory] = useState("");
  const [searchIndustry, setSearchIndustry] = useState("");
  const {
    selectedType,
    selectedTeritory,
    selectedIndustry,
    selectedStatus,
    syncEnabled,
  } = useSelector((state: any) => state.websiteAction);

  const filterConfig = [
    {
      key: "type",
      label: "Select Type",
      searchTerm: searchType,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchType(e.target.value),
      selectedOption: selectedType,
      filterName: "site_type",
      data: websiteList,
      onSelectionChange: (updatedSelection: any) =>
        store.dispatch(setSelectedType(updatedSelection)),
      count: selectedType && selectedType.length,
      colorSelected:
        selectedType !== null && selectedType.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "territory",
      label: "Select Territory",
      searchTerm: searchTeritory,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchTeritory(e.target.value),
      selectedOption: selectedTeritory,
      filterName: "territories__territory_name",
      data: websiteList,
      onSelectionChange: (updatedSelection: any) =>
        store.dispatch(setSelectedTeritory(updatedSelection)),
      count: selectedTeritory && selectedTeritory.length,
      colorSelected:
        selectedTeritory !== null && selectedTeritory.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "industry",
      label: "Select Industry",
      searchTerm: searchIndustry,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchIndustry(e.target.value),
      selectedOption: selectedIndustry,
      filterName: "industries__industry_name",
      data: websiteList,
      onSelectionChange: (updatedSelection: any) =>
        store.dispatch(setSelectedIndustry(updatedSelection)),
      count: selectedIndustry && selectedIndustry.length,
      colorSelected:
        selectedIndustry !== null && selectedIndustry.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "Status",
      label: "Select website Status",
      // searchTerm: searchStatus,
      // onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => setSearchStatus(e.target.value),
      selectedOption: selectedStatus,
      filterName: "is_active",
      data: websiteList,
      onSelectionChange: (updatedSelection: any) =>
        store.dispatch(setSelectedStatus(updatedSelection)),
      count: selectedStatus && selectedStatus.length,
      colorSelected:
      selectedStatus !== null && selectedStatus.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: false,
      valueMapping: { "1": "Online", "0": "Offline" },
    },
    {
      key: "Sync",
      label: "Select website sync status",
      // searchTerm: searchStatus,
      // onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => setSearchStatus(e.target.value),
      selectedOption: syncEnabled,
      filterName: "sync_enabled",
      data: websiteList,
      onSelectionChange: (updatedSelection: any) =>
        store.dispatch(setSyncEnabled(updatedSelection)),
      count: syncEnabled && syncEnabled.length,
      colorSelected:
      syncEnabled !== null && syncEnabled.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: false,
      valueMapping: { "1": "Active", "0": "Inactive" },
    },
    
  ];

  const clearFilters = () => {
    store.dispatch(setSelectedType([]));
    store.dispatch(setSelectedTeritory([]));
    store.dispatch(setSelectedIndustry([]));
    store.dispatch(setSelectedStatus([]));
    store.dispatch(setSyncEnabled([]));
    store.dispatch(setSelectedWebsite([]));
    setSearchType("");
    setSearchTeritory("");
    setSearchIndustry("");
  };

  return (
    <Box data-tracker="39">
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
}
